export const domain = 'CredentialsModel'

export const onEmailChange = `${domain}/onEmailChange`
export const onPasswordChange = `${domain}/onPasswordChange`
export const onFullNameChange = `${domain}/onFullNameChange`
export const onPhoneChange = `${domain}/onPhoneChange`
export const onSignInSuccess = `${domain}/onSignInSuccess`
export const onSetIsAcceptingTerms = `${domain}/onSetIsAcceptingTerms`
